export default "__VITE_ASSET__CRVho5FV__"